// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2S9-l","title":"Header_title__1yq0k","left":"Header_left__1EvhY","clinicName":"Header_clinicName__2zuKE"};